/** Standard editions referenced by Broadview. Stored clause keys keep their original edition label. */
export const STANDARDS_EDITION_NOTE =
  "IATF 16949:2016 is the current automotive edition (2nd edition planned). ISO 9001:2026 has been published; clause mappings below reference ISO 9001:2015 during the transition and should be re-verified against the licensed 2026 text.";

export const CONTROL_PLAN_NOTE =
  "Aligned to the AIAG Control Plan manual, 1st edition (CP-1): phases Prototype, Pre-launch, Safe Launch and Production. Safe Launch adds heightened controls during early production until stability is demonstrated.";

export const AP_VERIFY_NOTE =
  "Action Priority table follows the AIAG-VDA FMEA Handbook (2019). Some table cells await verification against a licensed copy of the handbook.";
